<template>
<div class="container-fluid" > 

<!-- Modal -->
<div class="modal" id="staticBackdrop_SalesPerMonth" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header ">
        <h5 class="modal-title" id="staticBackdropLabel">
            <i class="fas fa-list mr-2"></i>
            VENDITE PER MESE</h5>
       
      </div>
      <div class="modal-body">

        <div v-if="spinner" class="d-flex justify-content-center">
            <div class="spinner-border spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
       
        <div v-else>

            <table class="table">
                <thead>
                    <tr>
                    
                    <th scope="col">MESE</th>
                    <th class="text-right" scope="col">TOTALE €</th>
                    <th class="text-right" scope="col">SCONTO MEDIO</th>
                    </tr>
                </thead>
                <tbody>
                    <tr  v-for="(item, index) in data">
                        <td>{{ item.mese }}</td>
                        <td class="text-right">{{ fmt1(item.totale_mensile) }}</td>
                        <td class="text-right">{{ item.sconto_medio }} %</td>
                    </tr>
                </tbody>
                </table>    

            
        </div>

      </div>
      <div class="modal-footer">
        <button @click="closeModal()" type="button" class="btn btn-primary" >CHIUDI</button>
        
      </div>
    </div>
  </div>
</div>


</div>
</template>

<script>
//import api               from "@/api";
import { mapGetters }    from 'vuex';

import fmt               from '@/components/mixins/fmt'
export default {
    mixins     : [fmt],
    props      : ['data'],
  components: {
    
  },
  data() {
    return {


     
       spinner          : false
       
    }


  },

computed :{
    ...mapGetters(['company']),},

mounted: function() {
    //this.setData()

    

},
created: function() {
   
    this.$nextTick(()  => {
        $('#staticBackdrop_SalesPerMonth').modal('show')               
    
    })

    //console.log(this.data)
  },
 methods: 
  {
    closeModal()
    {
      $('#staticBackdrop_SalesPerMonth').modal('hide')
      this.$nextTick(()  => {              
        this.$emit('close')        
      })    
    },   

    
   
  }

};
</script>
<style scoped>
.modal-header{
    background-color : rgb(193, 193, 126);
    color            : black ;
}

</style>
